<div class="drop-area" (drop)="onDrop($event)">
  <p>Drop files here</p>
</div>
